import React, { useState } from "react";
import "./Tooltip.scss";

interface TooltipProps {
    content: string
    direction?: string,
    delay?: number,
    children: React.ReactElement,
}

const Tooltip: React.FC<TooltipProps> = (props: TooltipProps) => {
    let timeout: any;
    const [active, setActive] = useState(false);

    const showTip = () => {
        timeout = setTimeout(() => {
            setActive(true);
        }, props.delay || 500);
    };

    const hideTip = () => {
        clearInterval(timeout);
        setActive(false);
    };

    return (
        <div
            className="Tooltip-Wrapper"
            // When to show the tooltip
            onMouseEnter={showTip}
            onMouseLeave={hideTip}
            onClick={hideTip}
        >
            {/* Wrapping */}
            {props.children}
            {active && (
                <div className={`Tooltip-Tip ${props.direction || "left"}`}>
                    {/* Content */}
                    {props.content}
                </div>
            )}
        </div>
    );
};

export default Tooltip;
